import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
    return (
        <Container className="d-flex flex-column justify-content-center align-items-center vh-100">
            <h1 className="display-1 fw-bold">404</h1>
            <p className="fs-4 mb-4">Oops! The page you are looking for does not exist.</p>
            <Button as={Link} to="/dashboard" variant="primary">
                Go to Dashboard
            </Button>
        </Container>
    );
};

export default NotFoundPage;